import { useNode } from "@craftjs/core";
import React from "react";
import {
  ColorInput,
  SelectInput,
  UnitInput,
  Panel,
  Tabs,
  Spacer,
  AlignInput,
  ToggleInput,
  BoxShadowInput,
} from "../../input";
import { supportLibrary } from "../../block-supports";
import { isUpdatedFromDefault } from "../../utils";

export const ContentLockerInlineSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));

  const {
    align,
    alignMobile,
    alignTablet,
    dismissable,
    headingFontSize,
    headingFontSizeTablet,
    headingFontSizeMobile,
    descriptionFontSize,
    inputFontSize,
    buttonFontSize,
    cardBackgroundColor,
    headingColor,
    descriptionColor,
    buttonColor,
    buttonBackgroundColor,
    inputColor,
    inputBackgroundColor,
    cardShadow,
  } = props;

  function GeneralSettings() {
    return (
      <div className="g-settings__wrapper">
        <Spacer spacing="1rem">
          <div
            style={{
              padding: "10px",
              marginBottom: "15px",
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeeba",
              borderRadius: "4px",
              color: "#856404",
            }}
          >
            ⚠️ This content locker will hide all the content below this block
          </div>
          <ToggleInput
            isResetVisible={false}
            label="Dismissable"
            value={dismissable}
            onChange={(val) => {
              setProp((props) => {
                props.dismissable = val;
              });
            }}
          />
          <AlignInput
            resetValue={undefined}
            value={align}
            isResponsive={true}
            valueTablet={alignTablet}
            valueMobile={alignMobile}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.alignTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.alignMobile = val;
              });
            }}
            label={"Align"}
          />
        </Spacer>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: headingFontSize },
            { key: headingFontSizeTablet },
            { key: headingFontSizeMobile },
          ])}
          id={`block-setting-${id}-heading`}
          title={"Heading"}
          initialOpen={false}
        >
          <UnitInput
            isResponsive={true}
            resetValue={undefined}
            value={headingFontSize}
            valueTablet={headingFontSizeTablet}
            valueMobile={headingFontSizeMobile}
            onChange={(val) => {
              setProp((props) => {
                props.headingFontSize = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.headingFontSizeTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.headingFontSizeMobile = val;
              });
            }}
            label={"Font Size"}
          />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([{ key: descriptionFontSize }])}
          id={`block-setting-${id}-description`}
          title={"Description"}
          initialOpen={false}
        >
          <UnitInput
            resetValue={undefined}
            value={descriptionFontSize}
            onChange={(val) => {
              setProp((props) => {
                props.descriptionFontSize = val;
              });
            }}
            label={"Font Size"}
          />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([{ key: inputFontSize }])}
          id={`block-setting-${id}-input`}
          title={"Input"}
          initialOpen={false}
        >
          <UnitInput
            resetValue={undefined}
            value={inputFontSize}
            onChange={(val) => {
              setProp((props) => {
                props.inputFontSize = val;
              });
            }}
            label={"Font Size"}
          />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([{ key: buttonFontSize }])}
          id={`block-setting-${id}-button`}
          title={"Button"}
          initialOpen={false}
        >
          <UnitInput
            resetValue={undefined}
            value={buttonFontSize}
            onChange={(val) => {
              setProp((props) => {
                props.buttonFontSize = val;
              });
            }}
            label={"Font Size"}
          />
        </Panel>
      </div>
    );
  }

  function StyleSettings() {
    return (
      <>
        <Panel
          isUpdated={isUpdatedFromDefault([{ key: cardBackgroundColor }])}
          id={`block-setting-${id}-card`}
          title={"Card"}
          initialOpen={true}
        >
          <ColorInput
            resetValue={undefined}
            value={cardBackgroundColor}
            onChange={(val) => {
              setProp((props) => {
                props.cardBackgroundColor = val;
              });
            }}
            label={"Background Color"}
          />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: headingColor },
            { key: descriptionColor },
          ])}
          id={`block-setting-${id}-text`}
          title={"Text"}
          initialOpen={true}
        >
          <ColorInput
            resetValue={undefined}
            value={headingColor}
            onChange={(val) => {
              setProp((props) => {
                props.headingColor = val;
              });
            }}
            label={"Heading Color"}
          />
          <ColorInput
            resetValue={undefined}
            value={descriptionColor}
            onChange={(val) => {
              setProp((props) => {
                props.descriptionColor = val;
              });
            }}
            label={"Description Color"}
          />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: buttonColor },
            { key: buttonBackgroundColor },
          ])}
          id={`block-setting-${id}-button-style`}
          title={"Button"}
          initialOpen={true}
        >
          <ColorInput
            resetValue={undefined}
            value={buttonColor}
            onChange={(val) => {
              setProp((props) => {
                props.buttonColor = val;
              });
            }}
            label={"Color"}
          />
          <ColorInput
            resetValue={undefined}
            value={buttonBackgroundColor}
            onChange={(val) => {
              setProp((props) => {
                props.buttonBackgroundColor = val;
              });
            }}
            label={"Background Color"}
          />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: inputColor },
            { key: inputBackgroundColor },
          ])}
          id={`block-setting-${id}-input-style`}
          title={"Input"}
          initialOpen={true}
        >
          <ColorInput
            resetValue={undefined}
            value={inputColor}
            onChange={(val) => {
              setProp((props) => {
                props.inputColor = val;
              });
            }}
            label={"Color"}
          />
          <ColorInput
            resetValue={undefined}
            value={inputBackgroundColor}
            onChange={(val) => {
              setProp((props) => {
                props.inputBackgroundColor = val;
              });
            }}
            label={"Background Color"}
          />
        </Panel>
      </>
    );
  }

  function AdvancedSettings() {
    return (
      <>
        <Panel
          isUpdated={isUpdatedFromDefault([{ key: cardShadow }])}
          id={`block-setting-${id}-card-shadow`}
          title={"Card Shadow"}
          initialOpen={true}
        >
          <BoxShadowInput
            resetValue={undefined}
            value={cardShadow}
            onChange={(val) => {
              setProp((props) => {
                props.cardShadow = val;
              });
            }}
          />
        </Panel>
        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </>
    );
  }

  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: align },
        { key: alignTablet },
        { key: alignMobile },
        { key: dismissable },
        { key: headingFontSize },
        { key: headingFontSizeTablet },
        { key: headingFontSizeMobile },
        { key: descriptionFontSize },
        { key: inputFontSize },
        { key: buttonFontSize },
      ]),
    },
    {
      label: "Style",
      key: "style",
      children: StyleSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: cardBackgroundColor },
        { key: headingColor },
        { key: descriptionColor },
        { key: buttonColor },
        { key: buttonBackgroundColor },
        { key: inputColor },
        { key: inputBackgroundColor },
      ]),
    },
    {
      label: "Advanced",
      key: "advanced",
      children: AdvancedSettings(),
      isUpdated: isUpdatedFromDefault([{ key: cardShadow }]),
    },
  ];

  return (
    <div>
      <Tabs
        id={`block-settings-tab-${id}`}
        type="block-setting"
        items={tabs.map((item, i) => {
          return {
            label: item.label,
            key: item.key,
            children: item.children,
          };
        })}
      />
    </div>
  );
};
